
























import { Advertisement } from "@/interfaces/advertisement";
import Vue, { PropType } from "vue";
export default Vue.extend({
  props: {
    advertisement: Object as PropType<Advertisement>
  },
  data() {
    return {
      active: false
    };
  },
  methods: {
    async exec(cb: () => void) {
      if (!this.advertisement) {
        return;
      }
      await this.$store.dispatch("post", [
        this.advertisement["@id"] + "/suspend",
        this.advertisement
      ]);
      this.$emit("success");
      cb();
    }
  },
  computed: {
    disabled() {
      if (!this.advertisement.publicAdvertisement) {
        return true;
      }
      if (this.advertisement.publicAdvertisement.postStatus != "public") {
        return true;
      }
      if (!this.advertisement.publishmentOrder) {
        return true;
      }
      const unpublishesAt = new Date(
        this.advertisement.publishmentOrder.unpublishesAt
      );
      unpublishesAt.setHours(0);
      unpublishesAt.setDate(unpublishesAt.getDate() + 1);
      if (unpublishesAt < new Date()) {
        return true;
      }

      return false;
    }
  }
});
